// extracted by mini-css-extract-plugin
module.exports = {"lds-spinner":"LoadingIcon_lds-spinner__LaSEt"};